import usePA_GlobalStore from "../../Services/ZustandGlobalStore";
import {
    Alert,
    Button,
    Card,
    CardActionArea,
    Chip,
    CircularProgress, Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    InputAdornment, List, ListItem,
    Paper,
    Step,
    StepLabel,
    Stepper,
    TextField, Tooltip
} from "@mui/material";
import React, {useContext, useEffect, useMemo, useState} from "react";

import IconButton from "@mui/material/IconButton";
import {PAContext} from "../../Services/PAContext";
import Typography from "@mui/material/Typography";
import {
    browserStorageAddEvent,
    browserStorageAddTemplate, browserStorageReplacePlanningWithEvent,
    browserStorageUpdateSpecificEvent, browserStorageUpdateTemplate, getAllEventsFromDatabase,
    getEventFromDatabase, getTemplateFromDatabase
} from "../../Services/BrowserDatabaseFunctions";
import Box from "@mui/material/Box";
import {GoogleLogin} from "@react-oauth/google";
import {Visibility, VisibilityOff, Circle as BulletIcon} from "@mui/icons-material";
import {createTemplateFromEvent} from "../Helpers/EventConverter";
import PAEvent from "../../MasterEventObjects/PAEvent";
import {
    AlertCircle,
    CheckIcon,
    InfoIcon,
    LayersIcon,
    SparklesIcon,
    TagIcon, Sparkles, Info
} from "lucide-react";
import EventIcon from "@mui/icons-material/Event";
import ListItemIcon from "@mui/material/ListItemIcon";
import {usePoints} from "../../Services/PointsContext";


const keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
function encode64(input) {
    if (!input) return "";

    // First, we use TextEncoder to convert the string to a UTF-8 byte array.
    // Then, we convert those bytes to a string where each character
    // represents one byte (using map/fromCharCode).
    // Finally, btoa() creates the Base64 string.
    const bytes = new TextEncoder().encode(input);
    const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");
    return btoa(binString);
}


const steps = ['Verify Email', 'Enter Code', 'Set Password'];




function SavePlanning({isOpen, onClose}){

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage, setLoginFailed,
        removeFirstConciergeSignupActions, removeFirstEventUpgradeActions } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated, SignupPipeline, EventUpgradePipeline } = dataArray;

    const [saveAsTemplate, setSaveAsTemplate] = useState(PA_GlobalObject.Planning.template_id !== null);
    const [saveAsEvent, setSaveAsEvent] = useState(PA_GlobalObject.Planning.template_to_event.length > 0);

    const [isSaving, setIsSaving] = useState(false);

    function compareEventsOLD(planningEvent, databaseEvent) {
        const updatedSections = {};

        if (!databaseEvent) {
            return { all: planningEvent }; // If no old event exists, consider everything new
        }

        // Iterate through the keys of the event
        for (const key in planningEvent) {
            console.log("looking for changes to : "+key);

            if (planningEvent.hasOwnProperty(key) && !deepCompare(planningEvent[key], databaseEvent[key])) {
                updatedSections[key] = planningEvent[key];
            }
        }

        return updatedSections;
    }
    function deepCompare(obj1, obj2) {

        // If both are strictly equal (same reference or primitives), return true
        if (obj1 === obj2) return true;

        // If one is an object and the other is not, they are different
        if ((typeof obj1 === "object" && obj1 !== null) !== (typeof obj2 === "object" && obj2 !== null)) {
            console.log("❌ Type mismatch: One is an object, the other is not.");
            return false;
        }

        // If either is null/undefined, return false (this avoids Object.keys errors)
        if (!obj1 || !obj2) return false;

        // If they are arrays, compare lengths and items
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            return obj1.every((item, index) => deepCompare(item, obj2[index]));
        }

        // If they are objects, compare keys and values
        if (typeof obj1 === "object" && typeof obj2 === "object") {
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) return false;

            return keys1.every(key => deepCompare(obj1[key], obj2[key]));
        }

        // If none of the above conditions match, compare as primitive values
        return obj1 === obj2;
    }

    async function savePlanning(){
        console.log("savePlanning : ", PA_GlobalObject.Planning);

        //disable the SAVE button
        setIsSaving(true);

        //if the Planning is an event we look in the browser database pa_data.Events
        //otherwise we look in the pa_data.Templates

        if (!PA_GlobalObject.Planning.is_template){
            console.log("this is either 1) an Event or 2) a Planning that isn't yet an Event that we are saving");

            const _existing_planning = new PAEvent(PA_GlobalObject.Planning);

            //if they want to make a Template from the Event
            //see if a Template has already been made from this Event
            if (saveAsTemplate){

                const convertedEventToTemplate = createTemplateFromEvent(_existing_planning, SampleAttendees);

                //assign the template_id to the event if there wasn't one already
                if (_existing_planning.template_id === '') {
                    _existing_planning.template_id = convertedEventToTemplate.template_id;
                }

                browserStorageUpdateTemplate(convertedEventToTemplate).then((success) => {
                    if (success){
                        //the update was successful
                    } else {
                        //problems updating the Template

                    }
                })

                //if there is already a Template_id with this Event
                const _sendString = {};
                _sendString.action = PA_GlobalObject.Planning.template_id === null?"addNewTemplate":"updateTemplate"
                _sendString.template = convertedEventToTemplate;

                sendSocketMessage(_sendString);

            }



            const databaseEvent = await getEventFromDatabase(_existing_planning.id);

            console.log("databaseEvent from browser database : ", databaseEvent);

            if (databaseEvent){
                console.log("The Event does exist is the browser database");
                console.log("Checking for changes between the Planning version and the browser database version");

                // Perform the comparison
                const changes = compareEvents(_existing_planning, databaseEvent);

                if (Object.keys(changes).length > 0) {
                    console.log("There are changes : ",changes);

                    //update the browser database
                    console.log("Updating the Event in the browser storage ...");

                    browserStorageUpdateSpecificEvent(_existing_planning).then(success => {

                        console.log("Update success : "+success);

                        if (success){

                            console.log("Connected to server : ", dataArray.Websocket);
                            if (authenticated && PA_GlobalObject.Planning.status!== 10){
                                console.log("Connected to server!");
                                const _sendString = {};
                                _sendString.action = "E_saveEventUsingNewVersion";
                                _sendString.event_id = _existing_planning.id;
                                _sendString.planning_event = _existing_planning;
                                _sendString.changes = changes;

                                sendSocketMessage(_sendString);

                            }
                        } else {
                            //there were problems updating the Event in the database
                            console.log("Problems updating the browser database");
                        }
                    });

                } else {
                    console.log("There are NO changes with what we have in the browser database");

                    console.log("Connected to server : ", dataArray.Websocket);

                    if (dataArray.Websocket){
                        console.log("Connected to server!");

                        const _sendString = {};
                        _sendString.action = "E_saveEventUsingNewVersion";
                        _sendString.event_id = _existing_planning.id;
                        _sendString.planning_event = _existing_planning;
                        _sendString.changes = changes;

                        sendSocketMessage(_sendString);

                    }

                }

            } else {
                console.log("The Event wasn't found in the browser database");

                // Check for any sample attendees
                const hasSamples = _existing_planning.attendees.some(att => att.isSample);

                // Check if the current user is in the list of attendees
                const userIsAttendee = _existing_planning.attendees.some(att => att.id === Account.id);

                if (!hasSamples && userIsAttendee) {
                    // Safe to add the event to browser storage
                    browserStorageAddEvent(_existing_planning).then((success) => {
                        if (dataArray.Websocket) {
                            console.log("Connected to server! : ", _existing_planning);

                            const _sendPayload = {
                                action: "E_createNewEventFromPlanning",
                                event_id: _existing_planning.id,
                                planning_event: _existing_planning,
                            };

                            sendSocketMessage(_sendPayload);
                        }
                    });
                } else {
                    // Construct a more user-friendly message
                    let alertMessage = "";

                    if (hasSamples) {
                        alertMessage += "Sample attendees need to be removed before saving.\n";
                    }

                    if (!userIsAttendee) {
                        alertMessage += "You must be listed as a Planner, Host, or Guest in this Event.";
                    }

                    alert(alertMessage.trim());
                }

            }

        } else if (PA_GlobalObject.Planning.is_template) {
            console.log("this is a Template we are saving");

            //see if template exists
            const databaseTemplate = await getTemplateFromDatabase(usePA_GlobalStore.getState().PA_GlobalObject.Planning.template_id);

            if (databaseTemplate){
                console.log("found template", databaseTemplate);
                console.log("updating with ", PA_GlobalObject.Planning);

                //update the Template
                browserStorageUpdateTemplate(PA_GlobalObject.Planning).then(updatedTemplates => {
                    console.log("Updated Template:", updatedTemplates);



                });

            } else {
                console.log("template not found, need to add");
                browserStorageAddTemplate(PA_GlobalObject.Planning).then(addedTemplate => {
                    console.log("Added Template:", addedTemplate);

                    if (dataArray.Websocket){
                        console.log("Connected to server!");

                        const _sendString = {};
                        _sendString.action = "addNewTemplate";
                        _sendString.template_id = usePA_GlobalStore.getState().PA_GlobalObject.Planning.template_id;
                        _sendString.template_exists = false;
                        _sendString.planning_event = usePA_GlobalStore.getState().PA_GlobalObject.Planning;

                        sendSocketMessage(_sendString);

                    }
                });
            }

            //now if they want to save it as an Event we need to show them the pricing
            if (saveAsEvent){

                const _sendString = {};
                _sendString.action = "E_createNewEventFromPlanning";
                _sendString.planning_event = usePA_GlobalStore.getState().PA_GlobalObject.Planning;

                sendSocketMessage(_sendString);
            }
        }


    }

    function compareEvents(planningEvent, databaseEvent) {
        return compareEventsSmart(planningEvent, databaseEvent);
    }
    function compareEventsSmartOLD(newEvent, oldEvent) {
        // If oldEvent doesn't exist, everything is new
        if (!oldEvent) return { all: newEvent };

        const changes = {};

        for (const key in newEvent) {

            console.log("key ************** ", key);

            if (!newEvent.hasOwnProperty(key)) continue;

            const newVal = newEvent[key];
            const oldVal = oldEvent[key];

            // Primitive or different type
            if (!isObject(newVal) && !isArray(newVal)) {
                console.log("comparing ^^^^^ "+newVal+" #### "+oldVal);
                if (newVal !== oldVal) changes[key] = newVal;
                console.log("don't match so adding : ", changes[key]);
                continue;
            }

            // Arrays
            if (Array.isArray(newVal)) {
                // Array of primitives
                if (!isObjectArray(newVal)) {
                    const diff = newVal.filter((v, i) => oldVal?.[i] !== v);
                    if (diff.length) changes[key] = diff;
                    continue;
                }

                // Array of objects with IDs
                const arrayChanges = [];
                const oldMap = (oldVal || []).reduce((acc, item) => {
                    if (item.id) acc[item.id] = item;
                    return acc;
                }, {});

                newVal.forEach(item => {
                    if (item.id && oldMap[item.id]) {
                        const nestedChanges = compareEventsSmart(item, oldMap[item.id]);
                        if (Object.keys(nestedChanges).length) {
                            arrayChanges.push(nestedChanges);
                        }
                    } else {
                        // New item without match → include whole item
                        arrayChanges.push(item);
                    }
                });

                if (arrayChanges.length) changes[key] = arrayChanges;
                continue;
            }

            // Objects
            if (isObject(newVal)) {
                const nestedChanges = compareEventsSmart(newVal, oldVal);
                if (Object.keys(nestedChanges).length) {
                    changes[key] = nestedChanges;
                }
            }
        }

        console.log("%%%%%%%% changes", changes);

        return changes;
    }
    function compareEventsSmart(newEvent, oldEvent) {
        if (!oldEvent) return { all: newEvent }; // everything is new

        const changes = {};

        for (const key in newEvent) {
            if (!newEvent.hasOwnProperty(key)) continue;

            const newVal = newEvent[key];
            const oldVal = oldEvent[key];

            // Handle primitives (string, number, boolean, null/undefined)
            if (!isObject(newVal) && !Array.isArray(newVal)) {
                if (!primitiveEquals(newVal, oldVal)) {
                    changes[key] = newVal;
                }
                continue;
            }

            // Handle arrays
            if (Array.isArray(newVal)) {
                // Array of primitives
                if (!newVal.some(isObject)) {
                    if (!arraysEqual(newVal, oldVal)) {
                        changes[key] = newVal;
                    }
                    continue;
                }

                // Array of objects (with IDs)
                const arrayChanges = [];
                const oldMap = (oldVal || []).reduce((acc, item) => {
                    if (item.id) acc[item.id] = item;
                    return acc;
                }, {});

                newVal.forEach(item => {
                    if (item.id && oldMap[item.id]) {
                        const nestedChanges = compareEventsSmart(item, oldMap[item.id]);
                        if (Object.keys(nestedChanges).length) {
                            arrayChanges.push({ id: item.id, ...nestedChanges });
                        }
                    } else {
                        // New item → send full item
                        arrayChanges.push(item);
                    }
                });

                if (arrayChanges.length) {
                    changes[key] = arrayChanges;
                }
                continue;
            }

            // Handle objects
            if (isObject(newVal)) {
                const nestedChanges = compareEventsSmart(newVal, oldVal);
                if (Object.keys(nestedChanges).length > 0) {
                    changes[key] = nestedChanges;
                }
            }
        }

        return changes;
    }

    // Helpers
    function isObject(obj) {
        return obj && typeof obj === "object" && !Array.isArray(obj);
    }

    function primitiveEquals(a, b) {
        return a === b || (a == null && b == null); // treats undefined and null as equal if needed
    }

    function arraysEqual(a, b) {
        if (!a && !b) return true;
        if (!a || !b) return false;
        if (a.length !== b.length) return false;
        return a.every((v, i) => v === b[i]);
    }

    // Helpers
    function isArray(obj) {
        return Array.isArray(obj);
    }

    function isObjectArray(arr) {
        return Array.isArray(arr) && arr.length > 0 && typeof arr[0] === 'object';
    }

    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loginError, setLoginError] = useState('');

    const [signupPassword, setSignupPassword] = useState("");
    const [showSignupPassword, setShowSignupPassword] = useState(false);
    const [signupPasswordConfirm, setSignupPasswordConfirm] = useState("");
    const [showSignupPasswordConfirm, setShowSignupPasswordConfirm] = useState(false);

    const [signupError, setSignupError] = useState('');

    const handleOk = () => {
        console.log("handleOk");

        //check input values
        if (username.trim().length === 0) {
            setLoginError('The username cannot be blank');
            return false;
        }
        if (password.trim().length === 0) {
            setLoginError('The password cannot be blank');
            return false;
        }
        if (!dataArray.ws_connected) {
            setLoginError('Internet connection not found');
            return false;
        }

        setLoginError("");
        const _sendString = {};
        _sendString.action = "E_processUserLogin";
        _sendString.username = username;
        _sendString.password = encode64(password);

        sendSocketMessage(_sendString);
    };


    const [activeStep, setActiveStep] = useState(0);

    const [emailVerificationSent, setEmailVerificationSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [emailVerificationCodeMatches, setEmailVerificationCodeMatches] = useState(false);

    const [accountCreated, setAccountCreated] = useState(false);


    useEffect(() => {
        //handle the incoming action
        SignupPipeline.forEach(_incoming => {
            console.log('_incoming:', JSON.stringify(_incoming, null, '\t'));

            // Perform operations on the current action
            if (_incoming.result === "ok"){
                if (_incoming.action === "signupConciergeGetWelcomeMessageResults"){
                    //just landed on the page
//                    printConciergeMessageNextCharacter(_incoming.message);
                } else if (_incoming.action === "signupConciergeVerifyEmailAddressResults"){
                    //just sent them the email verification code
                    setEmailVerificationSent(true);
//                    printConciergeMessageNextCharacter(_incoming.message);
                } else if (_incoming.action === "signupConciergeVerifyVerificationCodeResults"){
                    //just checked the verification code
                    setEmailVerificationCodeMatches(true);
                    //ready to get passwords
                    setActiveStep(2);
//                    printConciergeMessageNextCharacter(_incoming.message);
                } else if (_incoming.action === "signupConciergeCheckUsernameAndPasswordResults"){
                    //just checked the login info - they can login now
                    setAccountCreated(true);
//                    printConciergeMessageNextCharacter(_incoming.message);
                }
            } else {
                //an error to show
//                printConciergeMessageNextCharacter(_incoming.message);

                if (_incoming.action === "signupConciergeVerifyEmailAddressResults"){
                    //something was wrong with the email address
                    setEmailVerificationSent(false);
                    setSignupError(_incoming.reason);
                    setActiveStep(0);
                } else if (_incoming.action === "signupConciergeVerifyVerificationCodeResults"){
                    //the email verification code doesn't match
                    setEmailVerificationCodeMatches(false);
                    setSignupError(_incoming.reason);
                    setActiveStep(1);
                } else if (_incoming.action === "signupConciergeCheckUsernameAndPasswordResults"){
                    //problems with the passwords
                    setAccountCreated(false);
                    setSignupError(_incoming.reason);
                    setActiveStep(2);
                }

            }
            removeFirstConciergeSignupActions();
        });

    }, [SignupPipeline])

    const handleNext = () => {

        if (activeStep === 0){
            if (validateEmail()){
                setSignupError("");

                const _send_string = {};
                _send_string.action = "signupConciergeVerifyEmailAddress";
                _send_string.email_address = email;

//                sendSocketMessage(_sendString);

                setActiveStep((activeStep) => activeStep + 1);

            } else {
                //need to fix something about the email address
                setSignupError("Email address not formatted properly");
            }

        } else if (activeStep === 1){
            //check verification code
            if (verificationCode.length !== 6) {
                setSignupError('The verification code must be 6 digits/characters.');
                return false;
            }

            setSignupError("");
            const _send_string = {};
            _send_string.action = "signupConciergeVerifyVerificationCode";
            _send_string.email_address = email;
            _send_string.verification_code = verificationCode;

//                sendSocketMessage(_sendString);

            setActiveStep((activeStep) => activeStep + 1);
        } else if (activeStep === 2){

            if (signupPassword.length < 8) {
                setSignupError('Password must be at least 8 characters long.');
                return false;
            }

            //check passwords match
            if (signupPassword !== signupPasswordConfirm) {
                setSignupError('Passwords do not match.');
                return false;
            }

            setSignupError("");
            const _send_string = {};
            _send_string.action = "signupConciergeCheckUsernameAndPassword";
            _send_string.email_address = email;
            _send_string.username = "";
            _send_string.password = encode64(signupPassword);
            _send_string.password_confirm = encode64(signupPasswordConfirm);

//               sendSocketMessage(_sendString);

            setAccountCreated(true);
        }


    }

    function validateEmail() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }


    const [promoCode, setPromoCode] = useState('');
    const [isPromoCodeChipDisabled, setIsPromoCodeChipDisabled] = useState(false);
    const [promoCodeMessage, setPromoCodeMessage] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState(30);
    const [discountAmount, setDiscountAmount] = useState(2);
    const [discountUnits, setDiscountUnits] = useState(null);

    useEffect(() => {
        const processEventPipeline = async () => {
            for (const _incoming of EventUpgradePipeline) {
                console.log('_incoming:', JSON.stringify(_incoming, null, '\t'));

                if (_incoming.result === "ok") {
                    if (_incoming.action === "E_checkNewEventPlanPromoCodeResults") {
                        if (_incoming.valid) {
                            setDiscountAmount(_incoming.amount);
                            setDiscountUnits(_incoming.units);

                            set_PA_GlobalObject(prev => ({
                                ...prev,
                                Planning: {
                                    ...prev.Planning,
                                    plan_promo_rate: _incoming.amount,
                                },
                            }));
                        } else {
                            setDiscountAmount(0); // Reset discount
                            setDiscountUnits(null);
                        }
                        setPromoCodeMessage(_incoming.admin_notes);
                        setIsPromoCodeChipDisabled(false);

                    } else if (_incoming.action === "E_createNewEventFromPlanningResults") {
                        // The planning has successfully become an Event

                        console.log("newly_created_event : ", _incoming.newly_created_event);

                        //reset the template identifiers
                        _incoming.newly_created_event.is_template = false;
                        _incoming.newly_created_event.template_id = null;
                        _incoming.newly_created_event.template_timestamp = null;
                        _incoming.newly_created_event.template_to_event = [];

                        try {
                            const success = await browserStorageReplacePlanningWithEvent(_incoming.newly_created_event);

                            if (success) {
                                console.log("Successfully added new Event to browser database");
                            } else {
                                console.log("NOT successfully added new Event to browser database");
                            }

                            // Update global state - Target only the 5 specific properties
                            set_PA_GlobalObject(prev => ({
                                ...prev,
                                Planning: {
                                    ...prev.Planning, // Keep dates, days, meals, lodging, activities, etc.
                                    id: _incoming.newly_created_event.id,
                                    is_template: false,
                                    template_id: null,
                                    template_timestamp: null,
                                    template_to_event: [],
                                    status: _incoming.newly_created_event.status
                                }
                            }));

                            //close the Dialog
                            onClose();

                        } catch (error) {
                            console.error("Error adding new Event to browser database:", error);
                        } finally {
                            setIsSaving(false);
                        }

                    } else if (_incoming.action === "E_saveEventUsingNewVersionResults") {

                        try {
                            const _applied_changes = _incoming.applied_changes;
                            const _rejected_changes = _incoming.rejected_changes;
                            const _changes = _incoming.changes;

                            console.log("_applied_changes : ", _applied_changes);
                            console.log("_rejected_changes : ", _rejected_changes);
                            console.log("_changes : ", _changes);

                            if (_incoming.result === "ok") {

                                //from the applied changes find the corresponding value from the _changes
                                /*
                                _applied_changes.map((change_field) => {
                                    //update the database
                                    browserStorageUpdateSpecificEventField(
                                        _incoming.event_id,
                                        change_field,
                                        _changes[change_field]
                                    ).then(result => {
                                            if (PA_GlobalObject.Planning.id === _incoming.event_id){

                                                set_PA_GlobalObject((prev) => ({
                                                    ...prev,
                                                    Planning: {
                                                        ...prev.Planning,
                                                       [ change_field ] : _changes[change_field]
                                                    },
                                                }));

                                            }
                                    });
                                });

                                 */

                                //close the Dialog
                                onClose();
                            }
                        } catch (e) {

                        } finally {
                            setIsSaving(false);
                        }
                    } else if (_incoming.action === "E_saveEventUsingNewVersionWithChangesResults") {

                        try {
                            const _applied_changes = _incoming.applied_changes;
                            const _changes = _incoming.changes;

                            console.log("_applied_changes : ", _applied_changes);
                            console.log("_changes : ", _changes);
                            console.log("WE ARE IGNORING ALL OF THESE CHANGES!!!");
                            if (_incoming.result === "ok"){

                                //from the applied changes find the corresponding value from the _changes
                                /*
                                                                    _applied_changes.map((change_field) => {
                                                                        //update the database
                                                                        browserStorageUpdateSpecificEventField(
                                                                            _incoming.event_id,
                                                                            change_field,
                                                                            _changes[change_field]
                                                                        ).then(result => {
                                                                                if (PA_GlobalObject.Planning.id === _incoming.event_id){

                                                                                    set_PA_GlobalObject((prev) => ({
                                                                                        ...prev,
                                                                                        Planning: {
                                                                                            ...prev.Planning,
                                                                                           [ change_field ] : _changes[change_field]
                                                                                        },
                                                                                    }));

                                                                                }
                                                                        });
                                                                    });

                                 */

                            }
                        } catch (e){
                        } finally {
                            setIsSaving(false);
                        }

                    }
                } else {
                    // Handle errors or failed actions
                    console.error("Error processing action:", _incoming.action);
                }

                removeFirstEventUpgradeActions();
            }
        };

        processEventPipeline(); // Call the async function inside useEffect

    }, [EventUpgradePipeline]); // Dependency array

    const handlePromoCodeChange = (e) => {
        setPromoCode(e.target.value);
        setPromoCodeMessage("");
        setIsPromoCodeChipDisabled(false);

        set_PA_GlobalObject(prev => ({
            Planning: {
                ...prev.Planning,
                plan_promo_code: e.target.value,
            },
        }));
    };
    function handleApplyPromoCode(){

        if (!promoCode.trim()) {
            setPromoCodeMessage("Please enter a valid promo code.");
            return;
        }

//        setIsPromoCodeChipDisabled(true);

        //check the promo code
        const _sendString = {};
        _sendString.action = "E_checkNewEventPlanPromoCode";
        _sendString.promo_code = promoCode;

        sendSocketMessage(_sendString);

    }
    function handlePayment(){

    }

    const handleClose = () => {
        setIsSaving(false);     // stop saving state
        onClose?.();            // safely call the parent-provided onClose
    };

    const [saveType, setSaveType] = useState('event'); // 'event' or 'template'
    const [promoMessage, setPromoMessage] = useState('');
    const [isApplying, setIsApplying] = useState(false);

    const BASE_PRICE = 7.99;

    const getDiscountValue = () => {
        if (discountAmount === 0 || !discountUnits) return 0;

        if (discountUnits === 'percent') {
            return (BASE_PRICE * discountAmount) / 100;
        }
        return discountAmount; // Fixed dollar amount
    };



    const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    /**
     * Stripe Checkout Implementation
     * The "Best Way" involves a backend call to create a session
     */
    const handleProceedToPayment = async () => {
        setIsProcessingPayment(true);
        try {
            // 1. Call your server to create a Stripe Checkout Session
            // const response = await fetch('/api/create-checkout-session', {
            //   method: 'POST',
            //   body: JSON.stringify({ promoCode, saveType, email })
            // });
            // const session = await response.json();

            // 2. Redirect to Stripe
            // window.location.href = session.url;

            // MOCK DELAY FOR DEMO
            await new Promise(r => setTimeout(r, 2000));
            console.log("Redirecting to Stripe with total: $" + calculateTotal());

        } catch (error) {
            console.error("Payment initiation failed", error);
        } finally {
            setIsProcessingPayment(false);
        }
    };

    const handleSaveWithoutPayment = async () => {
        setIsSaving(true);



        setIsSaving(false);
        // Proceed to success state


    };

// ==========================================
    // A. REWARDS GLOBAL CONTEXT HANDSHAKE
    // ==========================================
    const {
        totalAccountPoints,
        yearlyPoints,
        calculateSingleEventPoints,
        LOYALTY_BASE_PRICE,
        FLOOR_PRICE,
        getCurrentTier
    } = usePoints(); // <-- Sourced directly from your unified context

    // ==========================================
    // B. CURRENT ACTIVE EVENT LIVE REWARDS EXTRACTION
    // ==========================================
    const currentEventPoints = useMemo(() => {
        if (!PA_GlobalObject?.Planning || !Account?.id) return 0;

        // Calculate points dynamically for the unsaved active workspace itinerary
        const result = calculateSingleEventPoints(PA_GlobalObject.Planning, Account.id);
        return result.totalEventPoints || 0;
    }, [PA_GlobalObject?.Planning, Account?.id, calculateSingleEventPoints]);

    // ==========================================
    // C. INTEGRATED PRICING & TIER MATCHING ENGINE
    // ==========================================
    const checkoutPricingDetails = useMemo(() => {
        // Grand Sum: Profile Status + Past Database Records + Current Workspace Itinerary
        const combinedTotalPoints = totalAccountPoints + yearlyPoints + currentEventPoints;

        // Pull matched milestone config tier object from the shared core context engine
        const activeTier = getCurrentTier(combinedTotalPoints);

        // Compute tier boundary reductions against standard baseline setup bounds
        const calculatedTierPrice = Math.max(LOYALTY_BASE_PRICE - activeTier.discount, FLOOR_PRICE);

        return {
            combinedPoints: combinedTotalPoints,
            tierName: activeTier.label,
            appliedDiscount: activeTier.discount,
            tierCalculatedPrice: calculatedTierPrice
        };
    }, [totalAccountPoints, yearlyPoints, currentEventPoints, getCurrentTier, LOYALTY_BASE_PRICE, FLOOR_PRICE]);

    // ==========================================
    // D. DYNAMIC PROMOTIONAL CODE APPLIER
    // ==========================================
    const currentDiscountValue = useMemo(() => {
        if (!discountAmount || !discountUnits) return 0;

        const { tierCalculatedPrice } = checkoutPricingDetails;

        if (discountUnits === 'percent') {
            return (tierCalculatedPrice * discountAmount) / 100;
        }
        return discountAmount;
    }, [discountAmount, discountUnits, checkoutPricingDetails]);

    // ==========================================
    // E. BASKET GRAND TOTAL MATH
    // ==========================================
    const calculateTotal = () => {
        const { tierCalculatedPrice } = checkoutPricingDetails;
        const subtotal = tierCalculatedPrice - currentDiscountValue;
        return Math.max(0, subtotal).toFixed(2);
    };




    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>

            {/* Glassmorphic Dialog Header */}
            <DialogTitle
                component="div" // Ensures layout inside title context operates cleanly
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Left Side: Gradient Accent & Brand Typography Stack */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)',
                            flexShrink: 0
                        }}>
                            <i className="icon-floppy-disk" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 800,
                                    color: '#1e293b',
                                    fontSize: '1rem',
                                    letterSpacing: -0.4,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                Save {PA_GlobalObject.Planning.title || 'Your Journey'}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <Sparkles size={10} color="#8b5cf6" />
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: '#64748b',
                                        fontWeight: 700,
                                        fontSize: '0.65rem',
                                        letterSpacing: 0.1,
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Cloud Synchronization Engine
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Right Side: Window Control Actions */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {/* Contextual Layout Guide Button */}
                        <Tooltip title="Itinerary Rules">
                            <IconButton
                                sx={{
                                    color: '#64748b',
                                    transition: 'all 0.2s ease',
                                    '&:hover': { color: '#7c3aed', bgcolor: '#f5f3ff' }
                                }}
                            >
                                <Info size={20} />
                            </IconButton>
                        </Tooltip>

                        {/* Micro-Spaced Modal Escape Close Action */}
                        <Tooltip title="Cancel">
                            <IconButton
                                aria-label="close"
                                onClick={handleClose}
                                sx={{
                                    bgcolor: '#1e293b',
                                    color: 'white',
                                    borderRadius: '12px',
                                    width: '36px',
                                    height: '36px',
                                    boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: '#334155',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 6px 16px rgba(30, 41, 59, 0.3)',
                                    },
                                    '&:active': { transform: 'translateY(0px)' }
                                }}
                            >
                                <i className="icon-cross" style={{ fontSize: '14px', display: 'block' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </DialogTitle>
            {/* Dialog Content */}
            <DialogContent>
                {
                    !authenticated || Account.id === undefined ? (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {/* need to create an account or login */}
                            <Paper
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    maxWidth: '1100px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                }}
                            >

                                {/* Left Side: Options & Auth */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        padding: { xs: 3 },
                                        borderBottom: { xs: '1px solid #f1f5f9', md: 'none' },
                                        borderRight: { md: '1px solid #f1f5f9' },
                                        backgroundColor: '#ffffff'
                                    }}
                                >
                                    {!accountCreated ? (
                                        <Box>
                                            <Box sx={{ marginBottom: 4 }}>
                                                <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', marginBottom: 0.5 }}>
                                                    Join the Journey
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                                                    Before saving, you must be logged in to your account.
                                                </Typography>
                                            </Box>

                                            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'column' }, gap: 3 }}>
                                                {/* Sign-In Section */}
                                                <Box sx={{ flex: 1, padding: 3, border: '1px solid #f1f5f9', borderRadius: '20px', backgroundColor: '#f8fafc' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 3 }}>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Existing User? Sign In</Typography>
                                                    </Box>

                                                    <GoogleLogin
                                                        shape="pill"
                                                        onSuccess={credentialResponse => {
                                                            console.log(credentialResponse.credential);

                                                            setLoginFailed(false);

                                                            //send this to the server for processing
                                                            const _sendString = {};
                                                            _sendString.action = "E_processUserLoginUsingGoogleJWT";
                                                            _sendString.jwt = credentialResponse;

                                                            sendSocketMessage(_sendString);

                                                        }}
                                                        onError={() => {
                                                            console.log('Login Failed');
                                                        }}
                                                    />
                                                    <Divider sx={{ my: 3 }}>
                                                        <Typography variant="caption" sx={{ fontSize: '10px', fontWeight: 700, backgroundColor: '#fff' }}>OR</Typography>
                                                    </Divider>

                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                                                            <TextField
                                                                fullWidth
                                                                label="Username/Email"
                                                                size="small"
                                                                value={username}
                                                                onChange={(e) => setUsername(e.target.value)}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                            />
                                                            <TextField
                                                                fullWidth
                                                                label="Password"
                                                                size="small"
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                                                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* Feedback Area for Login Errors */}
                                                        <Collapse in={!!loginError}>
                                                            <Alert
                                                                severity="error"
                                                                icon={<i className="icon-warning" />}
                                                                sx={{
                                                                    mt: 1,
                                                                    borderRadius: '10px',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    backgroundColor: '#fef2f2',
                                                                    color: '#991b1b',
                                                                    border: '1px solid #fee2e2',
                                                                    '& .MuiAlert-icon': { color: '#ef4444' }
                                                                }}
                                                            >
                                                                {loginError}
                                                            </Alert>
                                                        </Collapse>
                                                        <Button
                                                            fullWidth
                                                            variant="contained"
                                                            onClick={handleOk}
                                                            sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 700, backgroundColor: '#1e293b', boxShadow: 'none' }}
                                                        >
                                                            Login
                                                        </Button>
                                                    </Box>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                    <Divider sx={{ flex: 1 }} />
                                                    <Typography variant="caption" sx={{ color: '#cbd5e1', fontWeight: 700 }}>NEW HERE?</Typography>
                                                    <Divider sx={{ flex: 1 }} />
                                                </Box>

                                                {/* Sign-Up Section */}
                                                <Box sx={{ flex: 1, padding: 3, border: '1px solid #f1f5f9', borderRadius: '20px', backgroundColor: '#f8fafc' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 3 }}>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Create New Account</Typography>
                                                    </Box>

                                                    <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
                                                        {steps.map((label) => (
                                                            <Step key={label}>
                                                                <StepLabel sx={{
                                                                    '& .MuiStepLabel-label': {
                                                                        fontSize: '11px',
                                                                        fontWeight: 700,
                                                                        color: '#94a3b8'
                                                                    },
                                                                    '& .MuiStepLabel-label.Mui-active': {
                                                                        color: '#10b981'
                                                                    },
                                                                    '& .MuiStepLabel-label.Mui-completed': {
                                                                        color: '#1e293b'
                                                                    }
                                                                }}>
                                                                    {label}
                                                                </StepLabel>
                                                            </Step>
                                                        ))}
                                                    </Stepper>

                                                    <Box sx={{ minHeight: '120px'}}>
                                                        {activeStep === 0 && (
                                                            <TextField
                                                                fullWidth
                                                                label="Email Address"
                                                                size="small"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                            />
                                                        )}
                                                        {activeStep === 1 && (
                                                            <TextField
                                                                fullWidth
                                                                label="Verification Code"
                                                                size="small"
                                                                value={verificationCode}
                                                                onChange={(e) => setVerificationCode(e.target.value)}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                            />
                                                        )}
                                                        {activeStep === 2 && (
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    label="Set Password"
                                                                    size="small"
                                                                    type={showSignupPassword ? 'text' : 'password'}
                                                                    value={signupPassword}
                                                                    onChange={(e) => setSignupPassword(e.target.value)}
                                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton onClick={() => setShowSignupPassword(!showSignupPassword)} edge="end">
                                                                                    {showSignupPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                                <TextField
                                                                    fullWidth
                                                                    label="Confirm"
                                                                    size="small"
                                                                    type={showSignupPasswordConfirm ? 'text' : 'password'}
                                                                    value={signupPasswordConfirm}
                                                                    onChange={(e) => setSignupPasswordConfirm(e.target.value)}
                                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff' } }}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton onClick={() => setShowSignupPasswordConfirm(!showSignupPasswordConfirm)} edge="end">
                                                                                    {showSignupPasswordConfirm ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Box>
                                                        )}
                                                        {/* Feedback Area for Signup Errors */}
                                                        <Collapse in={!!signupError}>
                                                            <Alert
                                                                severity="error"
                                                                icon={<i className="icon-warning" />}
                                                                sx={{
                                                                    mt: 1,
                                                                    borderRadius: '10px',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    backgroundColor: '#fef2f2',
                                                                    color: '#991b1b',
                                                                    border: '1px solid #fee2e2',
                                                                    '& .MuiAlert-icon': { color: '#ef4444' }
                                                                }}
                                                            >
                                                                {signupError}
                                                            </Alert>
                                                        </Collapse>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => setActiveStep(activeStep - 1)}
                                                            size="small"
                                                            sx={{ textTransform: 'none' }}
                                                        >
                                                            Back
                                                        </Button>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={handleNext}
                                                            size="small"
                                                            sx={{ borderRadius: '8px', textTransform: 'none', px: 3 }}
                                                        >
                                                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box>
                                            <Box sx={{ marginBottom: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <Box>
                                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', marginBottom: 0.5 }}>
                                                        Save Your Journey
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                                                        Choose how you want to keep this itinerary.
                                                    </Typography>
                                                </Box>
                                                <Chip
                                                    label="Logged In"
                                                    variant="outlined"
                                                    sx={{
                                                        borderRadius: '10px',
                                                        fontWeight: 700,
                                                        bgcolor: '#eff6ff',
                                                        color: '#1d4ed8',
                                                        border: '1px solid #dbeafe',
                                                        '& .MuiChip-deleteIcon': { color: '#1d4ed8', '&:hover': { color: '#1e40af' } }
                                                    }}
                                                />
                                            </Box>

                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginBottom: 4 }}>
                                                {/* Save Options */}
                                                <Card
                                                    elevation={0}
                                                    sx={{
                                                        borderRadius: '20px',
                                                        border: saveType === 'template' ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                                                        backgroundColor: saveType === 'template' ? 'rgba(59, 130, 246, 0.04)' : '#fff',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <CardActionArea onClick={() => setSaveType('template')} sx={{ padding: 3, display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: saveType === 'template' ? '#3b82f6' : '#f1f5f9', color: saveType === 'template' ? '#fff' : '#94a3b8', display: 'flex' }}>
                                                            <LayersIcon />
                                                        </Box>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Save as Template</Typography>
                                                            <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>Recurring route base with sample data.</Typography>
                                                        </Box>
                                                        {saveType === 'template' && <CheckIcon fontSize="small" sx={{ color: '#3b82f6' }} />}
                                                    </CardActionArea>
                                                </Card>

                                                <Card
                                                    elevation={0}
                                                    sx={{
                                                        borderRadius: '20px',
                                                        border: saveType === 'event' ? '2px solid #10b981' : '1px solid #e2e8f0',
                                                        backgroundColor: saveType === 'event' ? 'rgba(16, 185, 129, 0.04)' : '#fff',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                >
                                                    <CardActionArea onClick={() => setSaveType('event')} sx={{ padding: 3, display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: saveType === 'event' ? '#10b981' : '#f1f5f9', color: saveType === 'event' ? '#fff' : '#94a3b8', display: 'flex' }}>
                                                            <EventIcon />
                                                        </Box>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Save as Live Event</Typography>
                                                            <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>Real-time sync and active notifications.</Typography>
                                                        </Box>
                                                        {saveType === 'event' && <CheckIcon fontSize="small" sx={{ color: '#10b981' }} />}
                                                    </CardActionArea>
                                                </Card>
                                            </Box>

                                            {/* Promo Section */}
                                            {saveType === 'event' && (
                                                <Box sx={{ mt: 4 }}>
                                                    <Typography variant="overline" sx={{ color: '#94a3b8', fontWeight: 800, letterSpacing: '1px' }}>Promotion</Typography>
                                                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                                        <TextField
                                                            fullWidth size="small" placeholder="Try TRAVEL20"
                                                            value={promoCode}
                                                            onChange={(e) => setPromoCode(e.target.value)}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                                                            InputProps={{ startAdornment: <InputAdornment position="start"><TagIcon fontSize="small" /></InputAdornment> }}
                                                        />
                                                        <Button variant="contained" onClick={handlePromoCodeChange} sx={{ borderRadius: '12px', bgcolor: '#1e293b', px: 3, boxShadow: 'none' }}>
                                                            Apply
                                                        </Button>
                                                    </Box>
                                                    {promoMessage && (
                                                        <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 700, color: discountAmount > 0 ? '#10b981' : '#ef4444' }}>
                                                            {promoMessage}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </Box>

                                {/* Right Side: Summary/Finalize */}
                                <Box
                                    sx={{
                                        width: { md: '250px' },
                                        backgroundColor: 'rgba(248, 250, 252, 0.5)',
                                        padding: { xs: 4 },
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <Typography variant="overline" sx={{ color: '#94a3b8', fontWeight: 800, letterSpacing: '1.5px', mb: 4 }}>Summary</Typography>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Plan Type</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, textTransform: 'capitalize' }}>{saveType}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Price</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>{saveType === 'event' ? `$${BASE_PRICE}` : 'Free'}</Typography>
                                        </Box>

                                        {saveType === 'event' && currentDiscountValue > 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="body2" sx={{ color: '#10b981', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <SparklesIcon sx={{ fontSize: 16 }} /> Discount
                                                </Typography>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#10b981' }}>
                                                    -${getDiscountValue().toFixed(2)}
                                                </Typography>
                                            </Box>
                                        )}

                                        <Divider sx={{ my: 3 }} />

                                        {/* Feature List for Event Type */}
                                        <Collapse in={saveType === 'event'}>
                                            <Box sx={{ mb: 3 }}>
                                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, mb: 1, display: 'block' }}>INCLUDED FEATURES</Typography>
                                                <List sx={{ p: 0 }} dense>
                                                    {[
                                                        'Unlimited attendees',
                                                        'Secure document storage (Encrypted)',
                                                        'Passcode protection',
                                                        'Daily email notifications'
                                                    ].map((feature) => (
                                                        <ListItem key={feature} sx={{ p: 0, mb: 0.5, alignItems: 'flex-start' }}>
                                                            <ListItemIcon sx={{ minWidth: '18px', mt: 0.8 }}>
                                                                <BulletIcon sx={{ fontSize: '6px', color: '#10b981' }} />
                                                            </ListItemIcon>
                                                            <Typography variant="caption" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.4 }}>
                                                                {feature}
                                                            </Typography>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Box>
                                            <Divider sx={{ my: 3 }} />
                                        </Collapse>

                                        <Box>
                                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800 }}>Total Amount</Typography>
                                            <Typography variant="h4" sx={{ fontWeight: 900, mt: 1 }}>
                                                {saveType === 'event' ? `$${calculateTotal()}` : '$0.00'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ mt: 6, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        {calculateTotal() > 0 && saveType === 'event' ? (
                                            /* STRIPE PAYMENT BUTTON - The primary action for any balance */
                                            <>
                                                <Button
                                                    fullWidth variant="contained"
                                                    onClick={handleProceedToPayment}
                                                    disabled={!authenticated || isProcessingPayment}
                                                    startIcon={isProcessingPayment ? <CircularProgress size={20} color="inherit" /> : <i className="icon-debit-card" />}
                                                    sx={{
                                                        py: 2, borderRadius: '16px', fontWeight: 800,
                                                        bgcolor: '#6366f1', // Stripe-inspired Indigo
                                                        '&:hover': { bgcolor: '#4f46e5' }
                                                    }}
                                                >
                                                    {isProcessingPayment ? 'Connecting...' : 'Pay with Stripe'}
                                                </Button>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', color: '#94a3b8' }}>
                                                    <i className="icon-shield-check" />
                                                    <Typography variant="caption" sx={{ fontWeight: 600 }}>Secured by Stripe</Typography>
                                                </Box>
                                            </>

                                        ) : (
                                            /* STANDARD SAVE BUTTON - Used for Free or 100% Discounted items */
                                            <Button
                                                fullWidth variant="contained"
                                                onClick={savePlanning}
                                                disabled={!authenticated || isSaving}
                                                endIcon={!isSaving && <i className="icon-arrow-right" />}
                                                sx={{
                                                    py: 2, borderRadius: '16px', fontWeight: 800,
                                                    bgcolor: '#10b981',
                                                    '&:hover': { bgcolor: '#059669' }
                                                }}
                                            >
                                                {isSaving ? <CircularProgress size={24} color="inherit" /> : 'Confirm & Save'}
                                            </Button>
                                        )}
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                    ) : PA_GlobalObject.Planning.id === PA_GlobalObject.Planning.temp_id ? (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: { xs: 0, md: 2 }
                            }}
                        >
                            {/* have an account and save new Event */}
                            <Paper
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    maxWidth: '1100px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05)'
                                }}
                            >
                                {/* Left Side: Options & Config */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        padding: { xs: 2.5, md: 4 },
                                        borderBottom: { xs: '1px solid #f1f5f9', md: 'none' },
                                        borderRight: { md: '1px solid #f1f5f9' },
                                        backgroundColor: '#ffffff'
                                    }}
                                >
                                    <Box sx={{ marginBottom: 3 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', marginBottom: 0.5, letterSpacing: '-0.5px' }}>
                                            Save Your Journey
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                                            Choose how you want to keep this itinerary in your collection.
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, marginBottom: 3 }}>
                                        {/* Template Option */}
                                        <Card
                                            elevation={0}
                                            sx={{
                                                borderRadius: '16px',
                                                transition: 'all 0.2s ease',
                                                border: saveType === 'template' ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                                                backgroundColor: saveType === 'template' ? 'rgba(59, 130, 246, 0.02)' : '#fff'
                                            }}
                                        >
                                            <CardActionArea
                                                onClick={() => setSaveType('template')}
                                                sx={{ padding: 2, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 2 }}
                                            >
                                                <Box sx={{
                                                    padding: 1.2,
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                    backgroundColor: saveType === 'template' ? '#3b82f6' : '#f1f5f9',
                                                    color: saveType === 'template' ? '#ffffff' : '#94a3b8'
                                                }}>
                                                    <LayersIcon fontSize="small" />
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0.5 }}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '0.85rem' }}>
                                                            Save as Template
                                                        </Typography>
                                                        {saveType === 'template' && <CheckIcon fontSize="small" sx={{ color: '#2563eb' }} />}
                                                    </Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b', lineHeight: 1.4, display: 'block' }}>
                                                        Best for recurring routes. Includes sample attendees and no fixed dates.
                                                    </Typography>
                                                </Box>
                                            </CardActionArea>
                                        </Card>

                                        {/* Event Option */}
                                        <Card
                                            elevation={0}
                                            sx={{
                                                borderRadius: '16px',
                                                transition: 'all 0.2s ease',
                                                border: saveType === 'event' ? '2px solid #10b981' : '1px solid #e2e8f0',
                                                backgroundColor: saveType === 'event' ? 'rgba(16, 185, 129, 0.02)' : '#fff'
                                            }}
                                        >
                                            <CardActionArea
                                                onClick={() => setSaveType('event')}
                                                sx={{ padding: 2, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 2 }}
                                            >
                                                <Box sx={{
                                                    padding: 1.2,
                                                    borderRadius: '10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                    backgroundColor: saveType === 'event' ? '#10b981' : '#f1f5f9',
                                                    color: saveType === 'event' ? '#ffffff' : '#94a3b8'
                                                }}>
                                                    <EventIcon fontSize="small" />
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 0.5 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '0.85rem' }}>
                                                                Save as Live Event
                                                            </Typography>
                                                            <Chip
                                                                label="Premium"
                                                                size="small"
                                                                sx={{
                                                                    fontSize: '9px',
                                                                    height: '16px',
                                                                    fontWeight: 800,
                                                                    backgroundColor: '#ecfdf5',
                                                                    color: '#047857',
                                                                    borderColor: '#d1fae5'
                                                                }}
                                                            />
                                                        </Box>
                                                        {saveType === 'event' && <CheckIcon fontSize="small" sx={{ color: '#059669' }} />}
                                                    </Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b', lineHeight: 1.4, display: 'block' }}>
                                                        Unlock real dates, active notifications, and sync your contact list for reminders.
                                                    </Typography>
                                                </Box>
                                            </CardActionArea>
                                        </Card>
                                    </Box>

                                    {/* Contextual Warning for Event */}
                                    {saveType === 'event' && PA_GlobalObject.Planning.attendees?.some(att => att.isSample) && (
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                backgroundColor: '#fffbeb',
                                                border: '1px solid #fef3c7',
                                                borderRadius: '12px',
                                                padding: 2,
                                                display: 'flex',
                                                gap: 1.5,
                                                marginBottom: 2.5
                                            }}
                                        >
                                            <InfoIcon sx={{ color: '#f59e0b', marginTop: '2px' }} fontSize="small" />
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#92400e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 0.5 }}>
                                                    Notice: {PA_GlobalObject.Planning.attendees.length} Sample Attendees Detected
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#b45309', lineHeight: 1.4, display: 'block', fontSize: '0.75rem' }}>
                                                    As this is an actual event, sample data will be removed. You can add verified contacts once saved.
                                                </Typography>
                                            </Box>
                                        </Paper>
                                    )}

                                    {/* Promo Code UI */}
                                    {saveType === 'event' && (
                                        <Box sx={{ marginTop: 3 }}>
                                            <Typography variant="overline" sx={{ color: '#94a3b8', fontWeight: 800, letterSpacing: '0.5px', display: 'block', marginBottom: 0.5, fontSize: '0.65rem' }}>
                                                Promotion
                                            </Typography>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    placeholder="Enter code"
                                                    value={promoCode}
                                                    onChange={(e) => setPromoCode(e.target.value)}
                                                    disabled={isPromoCodeChipDisabled}
                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', fontSize: '13px', backgroundColor: '#f8fafc' } }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <TagIcon fontSize="small" sx={{ color: '#94a3b8' }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <Button
                                                    variant="contained"
                                                    onClick={handleApplyPromoCode}
                                                    disabled={isPromoCodeChipDisabled || isApplying}
                                                    sx={{ borderRadius: '10px', textTransform: 'none', backgroundColor: '#1e293b', px: 3, fontWeight: 700, boxShadow: 'none', '&:hover': { backgroundColor: '#0f172a' } }}
                                                >
                                                    {isApplying ? <CircularProgress size={18} color="inherit" /> : 'Apply'}
                                                </Button>
                                            </Box>
                                            {promoCodeMessage && (
                                                <Typography variant="caption" sx={{ fontWeight: 700, marginTop: 1, display: 'block', paddingX: 0.5, color: discountAmount > 0 ? '#10b981' : '#ef4444' }}>
                                                    {promoCodeMessage}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}
                                </Box>

                                {/* Right Side: Summary/Checkout */}
                                <Box sx={{
                                    width: { md: '280px' },
                                    backgroundColor: '#f8fafc',
                                    padding: { xs: 3, md: 4 },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderLeft: { md: '1px solid #e2e8f0' }
                                }}>
                                    <Typography variant="overline" sx={{ color: '#94a3b8', fontWeight: 800, letterSpacing: '1.5px', display: 'block', marginBottom: 3, fontSize: '0.7rem' }}>
                                        Summary
                                    </Typography>

                                    {/* VISIBLE LOYALTY CARD: Displays current status tier details & points */}
                                    {saveType === 'event' && checkoutPricingDetails && (
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                background: 'linear-gradient(135deg, #f0fdf4 0%, #e0f2fe 100%)',
                                                border: '1px solid #bae6fd',
                                                borderRadius: '12px',
                                                p: 1.5,
                                                mb: 2.5,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 0.5
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="caption" sx={{ color: '#0369a1', fontWeight: 800, fontSize: '0.65rem', uppercase: true, letterSpacing: '0.3px' }}>
                                                    YOUR REWARDS STATUS
                                                </Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, px: 1, py: 0.2, borderRadius: '20px', bgcolor: '#0284c7', color: '#fff' }}>
                                                    <i className="icon-star-full" style={{ fontSize: '8px' }} />
                                                    <Typography sx={{ fontSize: '9px', fontWeight: 900 }}>
                                                        {checkoutPricingDetails.combinedPoints || 0} pts
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Typography sx={{ color: '#0f172a', fontWeight: 900, fontSize: '0.95rem', mt: 0.5 }}>
                                                {checkoutPricingDetails.tierName || 'Explorer'} Tier
                                            </Typography>

                                            <Typography sx={{ color: '#047857', fontWeight: 600, fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                Custom status discount applied to baseline access rate.
                                            </Typography>
                                        </Paper>
                                    )}

                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Plan Type</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0f172a', textTransform: 'capitalize' }}>{saveType}</Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Base Access</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0f172a' }}>
                                                {saveType === 'event' ? `$${LOYALTY_BASE_PRICE.toFixed(2)}` : 'Free'}
                                            </Typography>
                                        </Box>

                                        {/* Loyalty Point Markdown Status Row */}
                                        {saveType === 'event' && (checkoutPricingDetails?.appliedDiscount > 0) && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="body2" sx={{ color: '#0284c7', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <i className="icon-star-full" style={{ fontSize: '12px' }} /> {checkoutPricingDetails.tierName} Tier
                                                </Typography>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#0284c7' }}>
                                                    -${checkoutPricingDetails.appliedDiscount.toFixed(2)}
                                                </Typography>
                                            </Box>
                                        )}

                                        {/* Promo Reduction Status Row */}
                                        {saveType === 'event' && currentDiscountValue > 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="body2" sx={{ color: '#10b981', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <SparklesIcon sx={{ fontSize: 16 }} /> Promo Discount
                                                </Typography>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#10b981' }}>
                                                    -${currentDiscountValue.toFixed(2)}
                                                </Typography>
                                            </Box>
                                        )}

                                        <Divider sx={{ marginY: 1.5, borderColor: '#e2e8f0' }} />

                                        <Box>
                                            <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.3px', display: 'block' }}>
                                                Total Amount
                                            </Typography>
                                            <Typography variant="h4" sx={{ fontWeight: 900, color: '#0f172a', lineHeight: 1, marginTop: 0.5, letterSpacing: '-0.5px' }}>
                                                {saveType === 'event' ? `$${calculateTotal()}` : '$0.00'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                        {calculateTotal() > 0 && saveType === 'event' ? (
                                            <>
                                                <Paper
                                                    elevation={0}
                                                    sx={{
                                                        backgroundColor: '#ffffff',
                                                        borderRadius: '12px',
                                                        padding: 1.5,
                                                        border: '1px solid #e2e8f0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1.5
                                                    }}
                                                >
                                                    <Box sx={{ backgroundColor: '#f1f5f9', padding: 0.8, borderRadius: '8px', color: '#94a3b8', display: 'flex', flexShrink: 0 }}>
                                                        <i className="icon-check-circle" style={{ fontSize: '20px', color: '#10b981' }} />
                                                    </Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b', lineHeight: 1.3, display: 'block', fontWeight: 600, fontSize: '0.7rem' }}>
                                                        Secure checkout. Your information is encrypted and protected.
                                                    </Typography>
                                                </Paper>

                                                <Button
                                                    fullWidth variant="contained"
                                                    onClick={handleProceedToPayment}
                                                    disabled={!authenticated || isProcessingPayment}
                                                    startIcon={isProcessingPayment ? <CircularProgress size={18} color="inherit" /> : <i className="icon-debit-card" />}
                                                    sx={{
                                                        py: 1.5, borderRadius: '12px', fontWeight: 800, textTransform: 'none', fontSize: '0.9rem',
                                                        bgcolor: '#6366f1', boxShadow: 'none',
                                                        '&:hover': { bgcolor: '#4f46e5' }
                                                    }}
                                                >
                                                    {isProcessingPayment ? 'Connecting...' : 'Pay with Stripe'}
                                                </Button>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', color: '#94a3b8' }}>
                                                    <i className="icon-shield-check" style={{ fontSize: '12px' }} />
                                                    <Typography variant="caption" sx={{ fontWeight: 700, fontSize: '0.65rem' }}>Secured by Stripe</Typography>
                                                </Box>
                                            </>
                                        ) : (
                                            <Button
                                                fullWidth variant="contained"
                                                onClick={savePlanning}
                                                disabled={!authenticated || isSaving}
                                                endIcon={!isSaving && <i className="icon-arrow-right" />}
                                                sx={{
                                                    py: 1.5, borderRadius: '12px', fontWeight: 800, textTransform: 'none', fontSize: '0.9rem',
                                                    bgcolor: '#10b981', boxShadow: 'none',
                                                    '&:hover': { bgcolor: '#059669' }
                                                }}
                                            >
                                                {isSaving ? <CircularProgress size={20} color="inherit" /> : 'Confirm & Save'}
                                            </Button>
                                        )}
                                        <Typography variant="caption" sx={{ textalign: 'center', color: '#94a3b8', display: 'block', paddingX: 1, lineHeight: 1.3, fontWeight: 600, fontSize: '0.65rem' }}>
                                            By clicking save, you agree to our <Box component="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }}>Terms of Service</Box>.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                    ) : PA_GlobalObject.Planning.is_template ? (
                        <Box
                            className="min-h-screen bg-slate-50 flex items-center justify-center p-4 md:p-8"
                            sx={{ fontFamily: 'Inter, sans-serif' }}
                        >
                            {/* save the Template changes */}
                            <Paper
                                elevation={0}
                                className="w-full max-w-4xl overflow-hidden flex flex-col md:flex-row border border-slate-200"
                                sx={{ borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.08)' }}
                            >

                                {/* Left Side: Primary Actions */}
                                <Box className="flex-1 p-6 md:p-10 border-b md:border-b-0 md:border-r border-slate-100 bg-white">
                                    <Box className="mb-8">
                                        <Box className="flex items-center gap-3 mb-2">
                                            <Box
                                                className="p-2 bg-emerald-100 text-emerald-600 rounded-xl flex items-center justify-center"
                                            >
                                                <i style={{fontSize:'22px'}} className={isSaving ? "icon-floppy-disk animate-spin" : "icon-floppy-disk"} />
                                            </Box>
                                            <Typography variant="h5" className="font-bold text-slate-800">
                                                Sync Changes
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" className="text-slate-500 italic">
                                            Updating your itinerary with the latest trip adjustments.
                                        </Typography>
                                    </Box>

                                    <Box className="space-y-6">
                                        {/* Main Update Info Card */}
                                        <Paper
                                            variant="outlined"
                                            className="p-5 rounded-2xl bg-slate-50/50 border-slate-100 flex gap-4"
                                            sx={{ borderRadius: '20px' }}
                                        >
                                            <Box className="p-3 bg-white shadow-sm rounded-xl text-emerald-500 h-fit flex items-center justify-center border border-slate-100">
                                                <i className="icon-cloud-upload" style={{fontSize:'20px'}} />
                                            </Box>
                                            <Box>
                                                <Typography variant="subtitle2" className="font-bold text-slate-800 mb-1">
                                                    Update Cloud Database
                                                </Typography>
                                                <Typography variant="caption" className="text-slate-500 leading-relaxed block">
                                                    This will synchronize all your latest edits, route changes, and notes to your permanent record.
                                                </Typography>
                                            </Box>
                                        </Paper>

                                        {/* Template Toggle Section */}
                                        <Box className="pt-4 border-t border-slate-100">
                                            <Typography
                                                variant="overline"
                                                className="text-slate-400 font-bold tracking-widest mb-4 block"
                                            >
                                                Secondary Action
                                            </Typography>

                                            <Card
                                                elevation={0}
                                                className={`transition-all duration-300 ${
                                                    saveAsTemplate
                                                        ? 'ring-2 ring-blue-500 bg-blue-50/30'
                                                        : 'border border-slate-200 hover:border-slate-300 bg-white'
                                                }`}
                                                sx={{ borderRadius: '20px', border: saveAsTemplate ? '2px solid #3b82f6' : '1px solid #e2e8f0' }}
                                            >
                                                <CardActionArea
                                                    onClick={() => setSaveAsTemplate(!saveAsTemplate)}
                                                    className="p-5 flex items-start gap-4"
                                                    sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}
                                                >
                                                    <Box className={`p-3 rounded-xl transition-colors flex items-center justify-center ${
                                                        saveAsTemplate ? 'bg-blue-500 text-white' : 'bg-slate-100 text-slate-400'
                                                    }`}>
                                                        <i className="icon-clock" style={{fontSize:'20px'}} />
                                                    </Box>
                                                    <Box className="flex-1">
                                                        <Box className="flex justify-between items-center mb-1">
                                                            <Typography variant="subtitle2" className="font-bold text-slate-800">
                                                                {PA_GlobalObject.Planning.template_id ? 'Update Existing Template' : 'Create New Template'}
                                                            </Typography>
                                                            <Box className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${
                                                                saveAsTemplate ? 'bg-blue-500 border-blue-500' : 'border-slate-200'
                                                            }`}>
                                                                {saveAsTemplate && <i style={{fontSize:'12px'}} className="icon-check text-white" />}
                                                            </Box>
                                                        </Box>
                                                        <Typography variant="caption" className="text-slate-500 block">
                                                            Capture this itinerary structure for future trips.
                                                        </Typography>
                                                    </Box>
                                                </CardActionArea>
                                            </Card>

                                            {/* Template Warning Logic */}
                                            {saveAsTemplate && PA_GlobalObject.Planning['time_table'].dates.length > 0 && (
                                                <Box
                                                    className="mt-4 bg-blue-50 border border-blue-100 rounded-xl p-4 flex gap-3 animate-in fade-in slide-in-from-top-2"
                                                >
                                                    <AlertCircle size={18} className="text-blue-500 shrink-0 mt-0.5" />
                                                    <Box>
                                                        <Typography variant="caption" className="text-blue-800 font-bold italic block mb-1">
                                                            Note on Dates
                                                        </Typography>
                                                        <Typography variant="caption" className="text-blue-700 leading-relaxed block">
                                                            Specific calendar dates will be removed from the template, but your sequence of days and relative timing will be preserved for reuse.
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Right Side: Execution & Summary */}
                                <Box
                                    className="w-full md:w-[340px] bg-slate-50/80 p-6 md:p-10 flex flex-col justify-between"
                                >
                                    <Box>
                                        <Typography
                                            variant="overline"
                                            className="text-slate-400 font-bold tracking-widest mb-6 block"
                                        >
                                            Action Summary
                                        </Typography>

                                        <Box className="space-y-4">
                                            <Box className="flex justify-between items-center">
                                                <Typography variant="body2" className="text-slate-600">Database Sync</Typography>
                                                <Chip
                                                    label="Ready"
                                                    size="small"
                                                    color="success"
                                                    variant="filled"
                                                    sx={{ fontWeight: 'bold', fontSize: '11px', height: '24px', backgroundColor: '#ecfdf5', color: '#059669', '& .MuiChip-icon': { color: 'inherit' } }}
                                                />
                                            </Box>

                                            <Box className="flex justify-between items-center">
                                                <Typography variant="body2" className="text-slate-600">Template Status</Typography>
                                                <Typography
                                                    variant="caption"
                                                    className={`font-bold ${saveAsTemplate ? 'text-blue-600' : 'text-slate-400'}`}
                                                >
                                                    {saveAsTemplate ? (PA_GlobalObject.Planning.template_id ? 'Updating' : 'Creating') : 'Disabled'}
                                                </Typography>
                                            </Box>

                                            <Divider className="my-6 border-slate-200" />

                                            <Box className="bg-amber-50 border border-amber-100 rounded-xl p-3 flex gap-2">
                                                <Typography variant="caption" className="text-amber-800 leading-tight font-medium">
                                                    This action will overwrite previous cloud states for this specific event ID.
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className="mt-8 space-y-4">
                                        {authenticated ? (
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                onClick={savePlanning}
                                                disabled={isSaving}
                                                sx={{
                                                    py: 2,
                                                    borderRadius: '16px',
                                                    textTransform: 'none',
                                                    fontWeight: 'bold',
                                                    fontSize: '1rem',
                                                    backgroundColor: '#0f172a',
                                                    boxShadow: '0 10px 15px -3px rgba(15, 23, 42, 0.2)',
                                                    '&:hover': {
                                                        backgroundColor: '#000',
                                                    }
                                                }}
                                            >
                                                {isSaving ? (
                                                    <CircularProgress size={24} color="inherit" />
                                                ) : (
                                                    'Confirm Updates'
                                                )}
                                            </Button>
                                        ) : (
                                            <Paper
                                                className="text-center p-4 bg-rose-50 border-rose-100"
                                                sx={{ borderRadius: '16px', border: '1px solid #ffe4e6' }}
                                                elevation={0}
                                            >
                                                <Typography variant="caption" className="text-rose-600 font-bold">
                                                    Please authenticate to save changes
                                                </Typography>
                                            </Paper>
                                        )}

                                        <Typography variant="caption" className="text-center text-slate-400 block px-4">
                                            Syncing ensures your itinerary is available across all your connected devices.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                    ): (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {/* Event already exists, just needs updating */}
                            <Paper
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    maxWidth: '1100px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: { xs: 'column', md: 'row' },
                                    borderRadius: '24px',
                                    border: '1px solid #f1f5f9'
                                }}
                            >
                                {/* Left Side: Sync & Config */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        padding: { xs: 3, md: 6 },
                                        borderBottom: { xs: '1px solid #f1f5f9', md: 'none' },
                                        borderRight: { md: '1px solid #f1f5f9' },
                                        backgroundColor: '#ffffff'
                                    }}
                                >
                                    <Box sx={{ marginBottom: 4 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                                            <Box sx={{
                                                p: 1, borderRadius: '10px', bgcolor: '#ecfdf5', color: '#10b981',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                                            }}>
                                                <i className="icon-cloud-upload" style={{ fontSize: '20px' }} />
                                            </Box>
                                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b' }}>
                                                Update Live Event
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
                                            Pushing the latest changes to your active itinerary and attendee dashboard.
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                        {/* Database Sync Card */}
                                        <Box sx={{
                                            p: 3, borderRadius: '20px', border: '1px solid #f1f5f9',
                                            bgcolor: '#f8fafc', display: 'flex', gap: 2
                                        }}>
                                            <Box sx={{
                                                p: 1.5, borderRadius: '12px', bgcolor: '#fff',
                                                color: '#10b981', display: 'flex', height: 'fit-content',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.02)', border: '1px solid #f1f5f9'
                                            }}>
                                                <i className="icon-check-circle" style={{ fontSize: '20px' }} />
                                            </Box>
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b' }}>
                                                    Cloud Synchronization
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#64748b', lineHeight: 1.5, display: 'block' }}>
                                                    This will update the real-time schedule, location data, and notes for all users connected to this event.
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Divider sx={{ my: 1 }}>
                                            <Typography variant="caption" sx={{ fontWeight: 800, color: '#cbd5e1', letterSpacing: '1px' }}>
                                                OPTIONS
                                            </Typography>
                                        </Divider>

                                        {/* Secondary Template Toggle */}
                                        <Card
                                            elevation={0}
                                            sx={{
                                                borderRadius: '20px',
                                                transition: 'all 0.3s ease',
                                                border: saveAsTemplate ? '2px solid #3b82f6' : '1px solid #e2e8f0',
                                                backgroundColor: saveAsTemplate ? 'rgba(59, 130, 246, 0.04)' : '#fff'
                                            }}
                                        >
                                            <CardActionArea onClick={() => setSaveAsTemplate(!saveAsTemplate)} sx={{ p: 3 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                    <Box sx={{
                                                        p: 1.5, borderRadius: '12px', display: 'flex',
                                                        bgcolor: saveAsTemplate ? '#3b82f6' : '#f1f5f9',
                                                        color: saveAsTemplate ? '#fff' : '#94a3b8'
                                                    }}>
                                                        <i className="icon-clock" style={{ fontSize: '20px' }} />
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                                                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                                                Save as Template Too
                                                            </Typography>
                                                            {saveAsTemplate && <i className="icon-check" style={{ color: '#3b82f6', fontSize: '14px' }} />}
                                                        </Box>
                                                        <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>
                                                            Check this to create a reusable blueprint based on these updates.
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </CardActionArea>
                                        </Card>

                                        {/* Dynamic Alert for Dates */}
                                        <Collapse in={saveAsTemplate && PA_GlobalObject.Planning['time_table'].dates.length > 0}>
                                            <Box sx={{
                                                p: 2, borderRadius: '16px', bgcolor: '#eff6ff',
                                                border: '1px solid #dbeafe', display: 'flex', gap: 2
                                            }}>
                                                <i className="icon-info-circle" style={{ color: '#3b82f6', marginTop: '2px' }} />
                                                <Typography variant="caption" sx={{ color: '#1e40af', fontWeight: 500, lineHeight: 1.4 }}>
                                                    <strong>Note:</strong> While the Live Event keeps its dates, the generated <strong>Template</strong> will use relative day numbers (Day 1, Day 2, etc.) for future reuse.
                                                </Typography>
                                            </Box>
                                        </Collapse>
                                    </Box>
                                </Box>

                                {/* Right Side: Summary & Action */}
                                <Box
                                    sx={{
                                        width: { md: '300px' },
                                        backgroundColor: 'rgba(248, 250, 252, 0.5)',
                                        padding: { xs: 4, md: 5 },
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <Typography variant="overline" sx={{ color: '#94a3b8', fontWeight: 800, letterSpacing: '1.5px', mb: 4, display: 'block' }}>
                                        Update Summary
                                    </Typography>

                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Sync Status</Typography>
                                            <Chip label="Ready" size="small" sx={{ fontWeight: 800, bgcolor: '#ecfdf5', color: '#059669', fontSize: '10px' }} />
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>Mode</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>Live Event</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>ID</Typography>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748b' }}>
                                                #{PA_GlobalObject.Planning.id.toString().slice(-5).toUpperCase()}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{ my: 1 }} />

                                        <Box sx={{ p: 2, borderRadius: '12px', bgcolor: '#fffbeb', border: '1px solid #fef3c7' }}>
                                            <Typography variant="caption" sx={{ color: '#92400e', fontWeight: 600, lineHeight: 1.3, display: 'block' }}>
                                                Updates are permanent and will overwrite the previous version of this event.
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ mt: 4 }}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={savePlanning}
                                            disabled={isSaving}
                                            sx={{
                                                py: 2, borderRadius: '16px', fontWeight: 800,
                                                bgcolor: '#1e293b', textTransform: 'none',
                                                boxShadow: '0 10px 15px -3px rgba(30, 41, 59, 0.2)',
                                                '&:hover': { bgcolor: '#0f172a' }
                                            }}
                                        >
                                            {isSaving ? <CircularProgress size={24} color="inherit" /> : 'Confirm Updates'}
                                        </Button>
                                        <Typography variant="caption" sx={{ textAlign: 'center', display: 'block', mt: 2, color: '#94a3b8', fontWeight: 500 }}>
                                            Auto-sync enabled for this journey.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                    )
                }
            </DialogContent>


            {/* Dialog Actions */}
            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SavePlanning;
